import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { getIcon } from "@/lib/icons";

export const DashletCard = ({ 
  icon, 
  label, 
  value, 
  expandable = false, 
  expandedContent = null,
  color = "#0066CC"
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div 
      className={`metric-card p-6 ${expandable ? 'cursor-pointer' : ''}`}
      onClick={() => expandable && setIsExpanded(!isExpanded)}
      data-testid={`dashlet-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4">
          <div 
            className="w-14 h-14 rounded-2xl flex items-center justify-center"
            style={{ backgroundColor: `${color}15` }}
          >
            {getIcon(icon, "h-7 w-7")}
          </div>
          <div>
            <p className="text-sm text-slate-500 font-medium">{label}</p>
            <p className="text-3xl font-bold text-slate-900 metric-value" style={{ color }}>
              {typeof value === 'number' ? value.toLocaleString() : value}
            </p>
          </div>
        </div>
        {expandable && (
          <button className="text-slate-400 hover:text-slate-600 p-1">
            {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
          </button>
        )}
      </div>

      {/* Expanded Content */}
      {expandable && isExpanded && expandedContent && (
        <div className="mt-6 pt-6 border-t border-slate-100 animate-fade-in-up">
          {expandedContent}
        </div>
      )}
    </div>
  );
};
